// Promo config — Coussin Massant Chauffant.
// Active du 30 septembre 2026 00:00 (Paris) au 12 octobre 2026 23:59:59 (Paris) inclus.
// Preview override : ajouter ?preview_promo=1 à l'URL pour forcer l'affichage avant le 30/09.

// Paris timezone offsets: CEST (UTC+2) until last Sunday of October, then CET (UTC+1).
// Sept 30 → Oct 12 is fully in CEST (+02:00).
const PROMO_START_MS = Date.UTC(2026, 8, 29, 22, 0, 0); // 2026-09-30 00:00 Paris = 22:00 UTC Sept 29
const PROMO_END_MS = Date.UTC(2026, 9, 12, 21, 59, 59); // 2026-10-12 23:59:59 Paris = 21:59:59 UTC Oct 12

export const PROMO = {
  discountPct: 13,
  startISO: "2026-09-30T00:00:00+02:00",
  endISO: "2026-10-12T23:59:59+02:00",
  // Manually-set promo prices (rounded to nearest cent — matches user spec exactly).
  prices: {
    "coussin-massant-chauffant": {
      "tissu-standard": { base: 79.0, promo: 68.7 },
      "velours-premium": { base: 89.0, promo: 77.4 },
    },
  },
};

const isPreviewOverride = () => {
  try {
    if (typeof window === "undefined") return false;
    return new URLSearchParams(window.location.search).get("preview_promo") === "1";
  } catch (_e) {
    return false;
  }
};

export const isPromoActive = () => {
  if (isPreviewOverride()) return true;
  const now = Date.now();
  return now >= PROMO_START_MS && now <= PROMO_END_MS;
};

// Returns { base, promo, discountPct } if the (product, variant) is on promo AND
// the window is active. Otherwise returns null.
export const getPromoPricing = (productId, variantId) => {
  if (!isPromoActive()) return null;
  const p = PROMO.prices[productId];
  if (!p) return null;
  const v = p[variantId];
  if (!v) return null;
  return { base: v.base, promo: v.promo, discountPct: PROMO.discountPct };
};

// Human-readable end date "12 octobre" (FR) / "October 12" (EN).
export const getPromoEndLabel = (lang = "fr") =>
  lang === "fr" ? "12 octobre" : "October 12";

// Full sentence "Offre jusqu'au 12 octobre" (used under CTAs).
export const getPromoBanner = (lang = "fr") =>
  lang === "fr"
    ? `Offre -${PROMO.discountPct}% jusqu'au ${getPromoEndLabel("fr")} inclus`
    : `-${PROMO.discountPct}% offer until ${getPromoEndLabel("en")} included`;
